import React from 'react';
import PropTypes from 'prop-types';
import { arrowWidth } from "../../config/defaults";

const TrackArrow = ({ transform, points, strokeColor }) => (
	<polyline
		stroke={strokeColor}
		strokeWidth={arrowWidth}
		strokeLinejoin="round"
		transform={transform}
		points={points}
	/>
);

TrackArrow.propTypes = {
	transform: PropTypes.string,
	points: PropTypes.string,
	strokeColor: PropTypes.string
};

export default TrackArrow;
